var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookParking = function SvgBookParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.232239 0.120117V15.7777H3.50915V10.8406H6.6016C9.90021 10.8406 12.1897 8.69217 12.1897 5.50206C12.1897 2.26855 9.98701 0.120117 6.76436 0.120117H0.232239ZM3.50915 2.72428H5.8963C7.78432 2.72428 8.85854 3.69 8.85854 5.51291C8.85854 7.29243 7.76262 8.26899 5.88545 8.26899H3.50915V2.72428Z",
    fill: "currentColor"
  })));
};
export default SvgBookParking;